module.exports = __webpack_public_path__ + "img/func-mobile.b5b9992a.png";